import React, {useState} from "react";
import cn from "classnames";
import styles from "./Player.module.sass";
import {ReactVideo, ReactAudio} from "reactjs-media";
import Slider from "react-slick";
import Icon from "../../components/Icon";
import {Modal as ModalAntd} from 'antd';

const SlickArrow = ({currentSlide, slideCount, children, ...props}) => (
    <button {...props}>{children}</button>
);

const Player = ({className, item, sizes = {h: 800, w: 640}}) => {
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState();

    const handleImgModalCancel = () => {
        setPreviewVisible(false);
    };

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: (
            <SlickArrow>
                <Icon name="arrow-next" size="14"/>
            </SlickArrow>
        ),
        prevArrow: (
            <SlickArrow>
                <Icon name="arrow-prev" size="14"/>
            </SlickArrow>
        ),
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    return (
        <div className={cn(styles.player, className)}>
            <div className={styles.preview}>

                {/*------------ Start Modal for uploaded image preview --------------*/}
                <ModalAntd
                    visible={previewVisible}
                    title="NFT Preview"
                    footer={null}
                    onCancel={handleImgModalCancel}
                    width={'90%'}
                >
                    <img alt="NFT Image" style={{width: '100%'}} src={previewImage}/>
                </ModalAntd>
                {/*------------ End Modal for uploaded image preview --------------*/}

                {item.type === 'image' && item.local_uri && !item?.gallery && (
                    <div className={cn(styles.img_container)}>
                        <img
                            srcSet={item.local_uri.replace('upload/', 'upload/b_rgb:' + process.env.REACT_APP_IMG_BG + ',c_pad,h_' + sizes.h * 2 + ',w_' + sizes.w * 2 + '/') + ' 2x'}
                            src={item.local_uri.replace('upload/', 'upload/b_rgb:' + process.env.REACT_APP_IMG_BG + ',c_pad,h_' + sizes.h + ',w_' + sizes.w + '/')}
                            alt="Preview"
                            className="nftImage"
                        />

                        <button
                            className={cn("button", styles.button_zoom)}
                            onClick={() => {
                                setPreviewVisible(true);
                                setPreviewImage(item.local_uri)
                            }}
                        >
                            <Icon name="zoom" size="40" viewBox="0 0 100 100"/>
                        </button>
                    </div>
                )}

                {/*if need image carousel*/}
                {item.type === 'image' && item.local_uri && item?.gallery && (

                    <div className={styles.slider_wrapper}>
                        <Slider className="player-slider" {...settings}>
                            {item.gallery.map((x, index) => (
                                <div className={styles.carousel_slide} key={index}>
                                    <div className={cn(styles.img_container)}>
                                        <img src={x} alt="Collection"/>
                                        <button
                                            className={cn("button", styles.button_zoom)}
                                            onClick={() => {
                                                setPreviewVisible(true);
                                                setPreviewImage(x)
                                            }}
                                        >
                                            <Icon name="zoom" size="40" viewBox="0 0 100 100"/>
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                )}

                {item.type === 'video' && (
                    <ReactVideo
                        src={item.local_uri}
                        primaryColor="red"
                        poster={(item.local_uri ? item.local_uri.replace(/\.([^\.]+)$/, '') + '.jpg' : false)}
                        className="nftVideo"
                    />
                )}

                {item.type === 'audio' && (
                    <ReactAudio
                        src={item.local_uri}
                        className="nftAudio"
                    />
                )}
            </div>
        </div>
    );
};

export default Player;
